import * as React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DettaglioCampagna from './dettaglio-campagna';
import HomeCampagna from './home-campagna';
import NuovaCampagna from './nuova-campagna';


const Campagne: React.FC = () => {

  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={path} component={HomeCampagna} exact />
      <Route path={`${path}/nuova`} component={NuovaCampagna} exact />
      <Route path={`${path}/:id`} component={DettaglioCampagna} exact />
    </Switch>
  )
}

export default Campagne;
